// ผลของการบันทึกแจ้งลา — server ข้ามคนที่มีการลาคาบเกี่ยวกับช่วงนี้อยู่แล้ว
// ไม่ว่าฝ่ายไหนเป็นคนแจ้ง (ดู server/utils/leaveOverlap.js) จึงต้องบอกครูว่าข้ามใครไป
// ไม่งั้นกดบันทึก 10 คน เข้าจริง 8 คน แล้วไม่มีอะไรบอก
//
// รับ response.data ตรงๆ ({ inserted, skipped }) — เส้นทางเก่าที่ยังไม่ส่งตัวเลขมา
// ตกไปที่ข้อความสำเร็จแบบเดิม แทนที่จะโชว์ "บันทึก undefined คน"
export const leaveSaveAlert = (data) => {
  const inserted = Number(data?.inserted);
  const skipped  = Number(data?.skipped);
  if (!Number.isFinite(inserted) || !Number.isFinite(skipped) || skipped === 0) {
    return { icon: 'success', title: 'บันทึกการลาสำเร็จ', timer: 1200, showConfirmButton: false };
  }
  if (inserted === 0) {
    return {
      icon: 'info',
      title: 'ไม่ได้บันทึกเพิ่ม',
      text: `นักเรียนที่เลือกทั้ง ${skipped} คน มีการแจ้งลาช่วงวันนี้อยู่แล้ว`,
    };
  }
  return {
    icon: 'success',
    title: `บันทึกการลา ${inserted} คน`,
    text: `ข้าม ${skipped} คน ที่มีการแจ้งลาช่วงวันนี้อยู่แล้ว`,
  };
};

export default leaveSaveAlert;
